<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 棋盘系统
                </el-breadcrumb-item>
				<el-breadcrumb-item>聊天记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.chatType" placeholder="请选择记录来源" style="width:180px">
					<el-option key="" label="请选择记录来源" value=""></el-option>
					<el-option key="0" label="微信" value="0"></el-option>
					<el-option key="1" label="QQ" value="1"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.status" placeholder="请选择状态" style="width:180px">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option key="0" label="未解析" value="0"></el-option>
					<el-option key="1" label="已解析" value="1"></el-option>
					<el-option key="2" label="解析失败" value="2"></el-option>
					<el-option key="3" label="已入库" value="3"></el-option>
				</el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column prop="chatType" label="来源" width="150">
					<template slot-scope="scope">
                        {{scope.row.chatType==0?"QQ":"微信"}}
                    </template>
				</el-table-column>
				<el-table-column prop="contacts" label="联系人" width="250"></el-table-column>
				<el-table-column prop="timeRange" label="时间段"></el-table-column>
				<el-table-column prop="status" label="状态" width="150">
					<template slot-scope="scope">
						<el-tag type="success" v-if="scope.row.status == 3">
							{{statusFormat(null, null, scope.row.status)}}
						</el-tag>
						<span v-else>
							{{statusFormat(null, null, scope.row.status)}}
						</span>
                    </template>
				</el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button
							type="text"
							icon="el-icon-view"
							@click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
						>详情</el-button>
                        <el-button
							type="text"
							icon="el-icon-refresh"
							@click="handleAnalysis(scope.$index, scope.row)"
							v-if="controll['analysis']"
						>解析</el-button>
						<el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		<v-Analysis ref="child"></v-Analysis>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="预览" :visible.sync="previewVisible" fullscreen>
			<div class="handle-box">
				<span>筛选：</span>
				<el-input v-model="filter.source" placeholder="聊天内容" class="handle-input mr10" style ="width:160px;"></el-input>
				<el-input v-model="filter.productName" placeholder="型号" class="handle-input mr10" style ="width:160px;"></el-input>
				<el-select v-model="filter.demandType" placeholder="请选择类型" style="width:180px">
					<el-option key="" label="请选择类型" value=""></el-option>
					<el-option key="报价" label="报价" value="报价"></el-option>
					<el-option key="询价" label="询价" value="询价"></el-option>
				</el-select>&nbsp;
				<el-select v-model="filter.status" placeholder="请选择状态" style="width:180px">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option key="0" label="待入库" value="0"></el-option>
					<el-option key="1" label="已入库" value="1"></el-option>
					<el-option key="2" label="入库失败" value="2"></el-option>
				</el-select>
			</div>
            <el-table
                :data="previewData.filter(data => (filter.source == '' || filter.source == undefined || data.source.includes(filter.source)) && (filter.productName == '' || filter.productName == undefined || data.source.includes(filter.productName)) && (filter.demandType == '' || filter.demandType == undefined || data.demandType.includes(filter.demandType)) && (filter.status == '' || filter.status == undefined || data.status == filter.status))"
				:key="editEnable"
                border
                class="table"
                ref="previewTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				height="580px"
				stripe
				@selection-change="handleSelectionChange"
            >
				<el-table-column type="selection" width="50" align="center" :selectable="isSelectable"></el-table-column>
				<el-table-column prop="source" label="聊天内容"></el-table-column>
				<el-table-column prop="productName" label="提取型号" width="180">
					<template slot-scope="scope">
						<el-input
						  v-if="scope.row.edit"
						  v-model="scope.row.productName"
						  placeholder="型号"
						></el-input>
						<span v-else>{{ scope.row.productName }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="demandType" label="类型" width="100">
					<template slot-scope="scope">
						<el-select v-model="scope.row.demandType" placeholder="请选择类型" v-if="scope.row.edit">
							<el-option key="报价" label="报价" value="报价"></el-option>
							<el-option key="询价" label="询价" value="询价"></el-option>
						</el-select>
						<span v-else>
							<el-tag :type= "scope.row.demandType == '报价'?'danger':(scope.row.demandType == '询价'?'success':'info')">{{scope.row.demandType}}
										</el-tag>
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="demandNum" label="数量" width="100">
					<template slot-scope="scope">
						<el-input
						  v-if="scope.row.edit"
						  v-model="scope.row.demandNum"
						  placeholder="数量"
						></el-input>
						<span v-else>{{ scope.row.demandNum }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="price" label="单价" width="100">
					<template slot-scope="scope">
						<el-input
						  v-if="scope.row.edit"
						  v-model="scope.row.price"
						  placeholder="单价"
						></el-input>
						<span v-else>{{ scope.row.price }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注" width="200">
					<template slot-scope="scope">
						<el-input
						  v-if="scope.row.edit"
						  v-model="scope.row.remark"
						  placeholder="备注"
						></el-input>
						<span v-else>{{ scope.row.remark }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="时间" width="160">
					<template slot-scope="scope">
						<el-input
						  v-if="scope.row.edit"
						  v-model="scope.row.createTime"
						  placeholder="时间"
						></el-input>
						<span v-else>{{ scope.row.createTime }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 2">
							<font color="red">入库失败</font>
						</span>
						<span v-else>{{scope.row.status == 0?"待入库":"已入库"}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="statusRemark" label="状态说明" width="180"></el-table-column>
				<el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button
							type="text"
							icon="el-icon-edit"
							v-if="scope.row.edit==undefined||scope.row.edit==false"
							@click="handleRowEdit(scope.$index, scope.row)"
						>编辑</el-button>
						<el-button
							type="text"
							icon="el-icon-check"
							v-if="scope.row.edit"
							@click="handleRowSave(scope.$index, scope.row)"
						>保存</el-button>
						<el-button
							type="text"
							icon="el-icon-refresh-left"
							v-if="(scope.row.edit==undefined||scope.row.edit==false) && scope.row.status == 2"
							@click="scope.row.status = 0"
						>初始化状态</el-button>
						<el-button
							type="text"
							icon="el-icon-close"
							v-if="scope.row.edit"
							@click="handleRowCancel(scope.$index, scope.row)"
						>取消</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-edit"
                    class="handle-del mr10"
                    @click="handleUpdateType"
                >变更类型</el-button>
				<el-dropdown split-button type="primary" @command="handleDataChange">
				  数据转换
				  <el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="np">数量转单价</el-dropdown-item>
					<el-dropdown-item command="pn">单价转数量</el-dropdown-item>
				  </el-dropdown-menu>
				</el-dropdown>
			</div>
            <span slot="footer" class="dialog-footer">
				<el-button @click="previewVisible = false">取 消</el-button>
				<el-button type="primary" @click="saveToChess">保存为棋招</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="批量更新类型" :visible.sync="demandTypeVisible" width="40%">
            <el-form ref="demandTypeForm" :model="demandTypeForm" label-width="120px"  :rules="demandTypeRules">
				<el-form-item label="类型" prop="demandType">
					<el-select v-model="demandTypeForm.demandType" placeholder="请选择类型">
						<el-option key="" label="请选择类型" value=""></el-option>
						<el-option key="报价" label="报价" value="报价"></el-option>
						<el-option key="询价" label="询价" value="询价"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
                <el-button @click="handleUpdateTypeCancel">取 消</el-button>
                <el-button type="primary" @click="updateDemandType" v-prevent-re-click>确 定</el-button>
            </span>
		</el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import vAnalysis from '../../common/Analysis.vue';
import { fetchChatRecordData, getChatRecord, deleteChatRecord, getChatRecordItem, 
saveToChessDemand, updateChatRecordItem, deleteChatRecordItem} from '../../../api/index';
export default {
    name: 'chat-record',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            pageTotal: 0,
			controll:{},
			previewVisible:false,
			previewData:[],
			rowBackUp:{},
			scrollTop:0,
			editEnable:false,
			multipleSelection:[],
			filter:{
				
			},
			currentId:0,
			demandTypeRules:{
				demandType: [{ required: true, message: '请选择更新类型', trigger: 'blur' }],
			},
			demandTypeVisible:false,
			demandTypeForm:{},
			selections:[]
        };
    },
    created() {
		this.controll = getControll("chat-record");
        this.getData();
    },
	components: {
        vAnalysis
    },
    methods: {
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchChatRecordData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
		isSelectable(row, index) {
			return row.status != 1;
		},
		//状态匹配
		statusFormat(row, column, cellValue) {
			let statusConfig = {"0":"未解析", "1":"已解析", "2":"解析失败","3":"已入库"};
			return statusConfig[cellValue];
		},
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteChatRecord([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		//添加操作
		handleAnalysis(index, row) {
			getChatRecord(row.id).then(res => {
				if (res.code == 0) {
					let source = "";
					let datas = res.data.content;
					for(var i = 0; i < datas.length; i++) {
						source = source + datas[i]["chessPlayer"] + "  " + datas[i]["time"] + "\r\n"
						source = source + datas[i]["content"] + "\r\n\r\n"
					}
					this.$refs.child.setAnalysisData(source, "chat", res.data.id, []);
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			});
		},
		handleShow(index, row) {
			this.currentId = row.id;
			this.showChatRecordItem();		 
		},
		showChatRecordItem() {
			getChatRecordItem(this.currentId).then(res => {
				if (res.code == 0) {
					this.previewData = [];
					for(var i = 0; i < res.data.length; i++){
						let item = JSON.parse(res.data[i].content);
						item["id"] = res.data[i].id;
						item["companyCode"] = res.data[i].companyCode;
						item["chatRecordId"] = res.data[i].chatRecordId;
						item["chessPlayer"] = res.data[i].chessPlayer;
						item["status"] = res.data[i].status;
						item["statusRemark"] = res.data[i].remark;
						this.previewData.push(item);
					}
					this.previewVisible = true;
				} else {
					this.$message.error(`获取聊天记录项失败！` + res.message);
				}
			})	
		},
		getTableScollTop() {
			this.scrollTop = this.$refs.previewTable.bodyWrapper.scrollTop;
		},
		setTableScollTop() {
			setTimeout(() => {
				this.$refs.previewTable.bodyWrapper.scrollTop = this.scrollTop;
			}, 13)
		},
		handleRowEdit(index, row) {
			this.getTableScollTop();
			this.rowBackUp = {};
			for(var item in row) {
				this.rowBackUp[item] = row[item];
			}
			row.edit = true;
			this.editEnable = true;
			this.setTableScollTop();
		},
		handleRowSave(index, row) {
			row.edit = false;
			this.editEnable = false;
			this.setTableScollTop();
			let submit = this.rowToSubmit(row);
			updateChatRecordItem([submit]).then(res => {
				if (res.code == 0) {
					this.$message.success(`更新成功！` + res.message);
				} else {
					this.$message.error(`更新失败！` + res.message);
				}
			})
		},
		handleRowCancel(index, row) {
			let isNotChange = true;
			delete row["edit"];
			for(var item in row) {
				isNotChange = this.rowBackUp[item] == row[item];
				if (!isNotChange) {
					break;
				}
			}
			if (isNotChange) {
				row.edit=false;
				this.editEnable = false;
				this.setTableScollTop();
				return;
			}
			this.$confirm('确定要取消修改吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					for(var item in row) {
						row[item]= this.rowBackUp[item]?this.rowBackUp[item]:"";
					}
					row.edit=false;
					this.editEnable = false;
					this.setTableScollTop();
                })
                .catch(() => {});
		},
		saveToChess() {
			let length = this.multipleSelection.length;
			if (length == 0){
				this.$message.error(`请选择要保存为棋招的记录！`);
				return;
			}
			this.$confirm('确定要将选中的记录保存为棋招吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					let submit = [];
					for(var i = 0; i < length; i++) {
						submit.push(this.rowToSubmit(this.multipleSelection[i]));
					}
					saveToChessDemand(submit).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功');
							this.showChatRecordItem();
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					});
				})
				.catch(() => {});
		},
		rowToSubmit(row) {
			let submit = {}
			let content = {}
			submit["id"] = row.id;
			submit["companyCode"] = row.companyCode;
			submit["chatRecordId"] = row.chatRecordId;
			submit["status"] = row.status;
			submit["chessPlayer"] = row.chessPlayer;
			content["productName"] = row["productName"];
			content["demandType"] = row["demandType"];
			content["source"] = row["source"];
			if (row["price"] != undefined) {
				content["price"] = row["price"];
			}
			if (row["match"] != undefined) {
				content["match"] = row["match"];
			}
			if (row["demandNum"] != undefined) {
				content["demandNum"] = row["demandNum"];
			}
			content["createTime"] = row["createTime"];
			submit["content"]= JSON.stringify(content);
			return submit;
		},
		// 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
		getIds() {
			const length = this.multipleSelection.length;
			if (length == 0) {
				return undefined;
			}
            let ids = [];
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			return ids;
		},
		delAllSelection() {
			let ids = this.getIds();
			if (ids == undefined){
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteChatRecordItem(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.showChatRecordItem();
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
		},
		handleUpdateType() {
			const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要变更类型的记录！`);
				return;
			}
			this.$set(this.demandTypeForm, 'demandType', '');
			this.selections = this.multipleSelection;
			this.demandTypeVisible = true;
			this.rowSelection();
		},
		updateDemandType() {
			const length = this.selections.length;
			if (length == 0) {
				this.$message.error(`请选择要变更类型的记录！`);
				return;
			}			
			this.$refs.demandTypeForm.validate(valid => {
				if (valid) {
					this.$confirm('确定要变更选中的记录类型吗？', '提示', {
						type: 'warning'
					})
						.then(() => {
							let submit = []
							for(var i = 0; i < length; i++) {
								this.$set(this.selections[i], "demandType", this.demandTypeForm.demandType);
								submit.push(this.rowToSubmit(this.selections[i]));
								this.$refs.previewTable.toggleRowSelection(this.selections[i], true);
							}
							updateChatRecordItem(submit).then(res => {
								if (res.code == 0) {
									this.demandTypeVisible = false;
									this.$message.success('变更成功');
									//this.showChatRecordItem();
								} else {
									this.$message.error(`变更失败！` + res.message);
								}
							});
						})
						.catch(() => {});
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
				
		},
		handleUpdateTypeCancel() {
			this.demandTypeVisible = false;
			this.rowSelection();
		},
		rowSelection() {
			setTimeout(function(vm){
				for(var i = 0; i < vm.selections.length; i++) {
					vm.$refs.previewTable.toggleRowSelection(vm.selections[i], true);
				}
			}, 200, this);
		},
		handleDataChange(command) {
			const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要转换的记录！`);
				return;
			}
			this.$confirm('确定要将选中记录的' + (command=="np"?"数量转单价":"单价转数量") + '吗？', '提示', {
						type: 'warning'
			})
				.then(() => {
					let submit = []
					for(var i = 0; i < length; i++) {
						if (command=="np") {
							let num = this.multipleSelection[i].demandNum;
							this.$set(this.multipleSelection[i], "price", num);
							this.$set(this.multipleSelection[i], "demandNum", "");
						}
						if (command=="pn") {
							let price = this.multipleSelection[i].price;
							this.$set(this.multipleSelection[i], "demandNum", price);
							this.$set(this.multipleSelection[i], "price", "");
						}
						
						submit.push(this.rowToSubmit(this.multipleSelection[i]));
					}
					updateChatRecordItem(submit).then(res => {
						if (res.code == 0) {
							this.demandTypeVisible = false;
							this.$message.success('转换成功');
							//this.showChatRecordItem();
						} else {
							this.$message.error(`转换失败！` + res.message);
						}
					});
				})
				.catch(() => {});
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

.edit-container {
  height: 570px;
  padding: 10px 20px;
}

.edit {
  display: flex;
  height: 530px;
}

.leftBox {
  width: 45px;
  height: 100%;
  text-align: left;
}

.area-content {
  padding: 10px 8px;
  width: 100%;
  height: 100%;
  font-size: 13px;
  line-height: 24px;
  color: #2dc26b;
  font-family: Consolas;
  border: none;
  background: #373737;
  box-sizing: border-box;
  outline: none;
  resize: none;
}

#leftNum {
  padding: 10px 4px;
  height: 100%;
  width: 100%;
  line-height: 24px;
  font-size: 13px;
  text-align: right;
  color: #fff;
  font-weight: bold;
  resize: none;
  outline: none;
  border: 0;
  background: black;
  box-sizing: border-box;
  overflow-y: hidden;
  overflow-x: hidden;
}

.spiltBar:hover{ 
	filter:alpha(Opacity=100);
	-moz-opacity:1;
	opacity:1;
}

.spiltBar{
	height:600px;
	width:10px;
	position:absolute;
	margin-left:-15px;
	text-align:center;
	line-height:600px;
	cursor: pointer;
	filter:alpha(Opacity=60);
	-moz-opacity:0.6;
	opacity:0.6;
}

</style>
